export default "__VITE_ASSET__7072098f__"